import React from "react";
import CheckBox from "../../../../CheckBox/CheckBox";

const BodyTransformation = ({
  bodyTransformationData,
  setBodyTransformationData,
  handleIncrementSession,
  handleDecrementSession,
}) => {
  return (
    <div className="overflow-x-auto md:overflow-x-visible rounded-xl">
      <div className="w-[628px] sm:w-full">
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040]">
          <div className="h-[56px] bg-[#D9D9D9] border-b-2 rounded-t-xl border-b-solid border-b-[#8C8C8C] grid grid-cols-8">
            <div className="flex justify-center items-center">
              <CheckBox
                id="terms"
                type="heading"
                onChecked={(e) => {
                  const data = bodyTransformationData?.map((item) => {
                    return {
                      ...item,
                      isChecked: e,
                    };
                  });
                  setBodyTransformationData(data);
                }}
                isChecked={bodyTransformationData?.every(
                  (item) => item?.isChecked
                )}
              />
            </div>
            <div className="col-span-3 flex items-center">
              <p className="font-font-Titillium font-bold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase">
                Package
              </p>
            </div>
            <div className="col-span-2 flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-center">
                No. of Sessions/ Frequency
              </p>
            </div>
            <div className="col-span-2 flex justify-center items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-center">
                Price
              </p>
            </div>
          </div>
          {bodyTransformationData?.slice(0, 3)?.map((item, index) => (
            <div
              key={index + 1}
              className="h-[56px] border-b border-b-solid border-b-[#D9D9D9] grid grid-cols-8"
            >
              <div className="flex justify-center items-center">
                <CheckBox
                  id="terms"
                  onChecked={(e) => {
                    const data = bodyTransformationData?.map((item, i) => {
                      if (i !== index) return item;
                      return {
                        ...item,
                        isChecked: e,
                      };
                    });
                    setBodyTransformationData(data);
                  }}
                  isChecked={bodyTransformationData[index]?.isChecked}
                />
              </div>
              <div className="col-span-3 flex items-center">
                <p className="font-font-Titillium font-bold text-[16px] leading-[19.2px] tracking-[0.0156em]">
                  {item?.package}
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center">
                <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
                  <div className="flex">
                    <div className="flex mr-2">
                      <button
                        className="bg-[#D9D9D9] rounded-sm text-[22px] w-[16px] h-[16px] leading-[20.8px] flex justify-center items-end"
                        onClick={() => handleDecrementSession(index)}
                      >
                        -
                      </button>{" "}
                      <p className="mx-2">{item?.sessions}</p>{" "}
                      <button
                        className="bg-[#D9D9D9] rounded-sm text-[18px] w-[16px] h-[16px] leading-[20.8px] flex justify-center items-end"
                        onClick={() => handleIncrementSession(index)}
                      >
                        +
                      </button>{" "}
                    </div>
                    <p>Session(s)</p>
                  </div>
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center ">
                <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
                  £{item?.price}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 h-[88px] grid grid-cols-8">
          <div className="flex justify-center items-start pt-5">
            <CheckBox
              id="terms"
              onChecked={(e) => {
                const data = bodyTransformationData?.map((item, i) => {
                  if (i !== 3) return item;
                  return {
                    ...item,
                    isChecked: e,
                  };
                });
                setBodyTransformationData(data);
              }}
              isChecked={bodyTransformationData[3]?.isChecked}
            />
            {/* <input
                  id="default-checkbox"
                  type="checkbox"
                  value={''}
                  className="w-4 h-4 border border-solid border-[#8C8C8C] rounded-sm "
                  style={{ display: "block" }}
                /> */}
          </div>
          <div className="col-span-3 flex flex-col justify-center">
            <p className="font-font-Titillium font-bold text-[16px] leading-[19.2px] tracking-[0.0156em] text-[#141414]">
              Add On: Body analysis
            </p>
            <p className="font-font-Titillium font-light text-[14px] leading-[16.8px] tracking-[0.025em] text-[#000000]">
              Includes - Body fat, Acidity test, Blood Pressure, BMR, Lean Mass
            </p>
          </div>
          <div className="col-span-2 flex  justify-center pt-5">
            <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
              <div className="flex">
                <p>1 Session</p>
              </div>
            </p>
          </div>
          <div className="col-span-2 flex  justify-center pt-5">
            <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
              £45
            </p>
          </div>
        </div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 h-[56px] grid grid-cols-8">
          <div className="col-span-[200px]"></div>
          <div className="col-span-5 flex items-center">
            <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-[#141414]">
              Total Charge:
            </p>
          </div>
          <div className="col-span-2 flex items-center justify-center ">
            <div className="rounded-xl bg-[#F5F5F5] w-[120px] h-[40px] flex items-center justify-center ">
              <p className="font-font-Titillium font-semibold text-[18px] leading-[27px] tracking-[0.0313] text-center">
                £
                {bodyTransformationData?.reduce(
                  (prev, curr) => (curr.isChecked ? prev + curr.price : prev),
                  0
                ) || 0}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BodyTransformation;
